/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Number_To_Keep_HelpInputs */

const en_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Older backups will be automatically removed`)
};

const fr_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les anciennes sauvegardes seront supprimées automatiquement`)
};

const de_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ältere Backups werden automatisch entfernt.`)
};

const it_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I backup più vecchi verranno rimossi automaticamente`)
};

const ru_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Более старые резервные копии будут удалены автоматически.`)
};

const es_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las copias de seguridad más antiguas se eliminarán automáticamente`)
};

const zh_cn2_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较旧的备份将被自动删除。`)
};

const ja_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`古いバックアップは自動的に削除されます`)
};

const hi_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुराने बैकअप अपने आप हटा दिए जाएंगे`)
};

const pt_pt2_options_backup_number_to_keep_help = /** @type {(inputs: Options_Backup_Number_To_Keep_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os backups mais antigos serão removidos automaticamente.`)
};

/**
* | output |
* | --- |
* | "Older backups will be automatically removed" |
*
* @param {Options_Backup_Number_To_Keep_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_number_to_keep_help = /** @type {((inputs?: Options_Backup_Number_To_Keep_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Number_To_Keep_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_number_to_keep_help(inputs)
	if (locale === "de") return de_options_backup_number_to_keep_help(inputs)
	if (locale === "it") return it_options_backup_number_to_keep_help(inputs)
	if (locale === "ru") return ru_options_backup_number_to_keep_help(inputs)
	if (locale === "es") return es_options_backup_number_to_keep_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_number_to_keep_help(inputs)
	if (locale === "ja") return ja_options_backup_number_to_keep_help(inputs)
	if (locale === "hi") return hi_options_backup_number_to_keep_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_number_to_keep_help(inputs)
	return en_options_backup_number_to_keep_help(inputs)
});